import { FILE_EXTENSION } from '../../shared/constants/file/FILE_EXTENSIONS';
import { apiReportService } from '../../shared/services/apiService';
import { getApiUrlRole } from '../../shared/utils/apiUtils';
import { downloadReportFile } from '../utils';
import { DownloadParams } from '../interfaces/DownloadParams';
import { GetReportsListResponse } from '../interfaces/GetReportsListResponse';

const { PDF, CSV } = FILE_EXTENSION;

export const salesReportService = {
  async getReports() {
    const apiUrlRole = getApiUrlRole();

    const resp = await apiReportService.get<GetReportsListResponse>(
      `/api/${apiUrlRole}/sales-reports/list`,
    );

    return resp.data;
  },

  async downloadReportPDF(reportType: string, params: DownloadParams) {
    const apiUrlRole = getApiUrlRole();

    const resp = await apiReportService.get<ArrayBuffer>(
      `api/${apiUrlRole}/sales-report/download/${reportType}`,
      { params, responseType: 'arraybuffer' },
    );

    downloadReportFile(resp.data, reportType, PDF);
  },

  async downloadReportCSV(reportType: string, params: DownloadParams) {
    const apiUrlRole = getApiUrlRole();

    const resp = await apiReportService.get<string>(
      `api/${apiUrlRole}/sales-report/download-csv/${reportType}`,
      { params, responseType: 'text' },
    );

    downloadReportFile(resp.data, reportType, CSV);
  },
};
